module.exports = __webpack_public_path__ + "img/软著案例icon.a25934da.png";